import React, { useEffect, useRef } from 'react';

const directionMap = {
  left: 'from-left',
  right: 'from-right',
  up: 'from-up',
  down: 'from-down',
};

export default function ScrollReveal({ children, direction = 'up', delay = 0, threshold = 0.15, rootMargin = '0px 0px -80px 0px', className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    el.style.transitionDelay = `${delay}ms`;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
          observer.unobserve(el);
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [delay, threshold, rootMargin]);

  const dirClass = directionMap[direction] || 'from-down';

  return (
    <div ref={ref} className={`reveal ${dirClass} ${className}`}>
      {children}
    </div>
  );
}
